import axiosPost from "../axiosPost";

export const migraTipoDePasoDel = async ({ migraTipoDePasoId }, credentials) => {
    const body = {
        service: "MigraTipoDePasoDel",
        params: {
            migraTipoDePasoId,
        },
    };

    return await axiosPost(body, credentials);
};
